import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    policies: [],
    policy: null,
    links: null,
    meta: null,
    filter: {
      keyword: null,
      productCategoryId: null,
      productId: null,
      buId: null,
      buIds: [],
      popularcfg: '',
    },
  },
  mutations: {
    CLEAR_ALL(state) {
      state.filter = {
        keyword: null,
        productCategoryId: null,
        productId: null,
        buId: null,
        buIds: [],
        popularcfg: '',
      };
      state.policies = [];
      state.policy = null;
    },
    SET_POLICIES(state, data) {
      state.policies = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_POLICY(state, data) {
      state.policy = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setPolicy({ commit }, data) {
      commit('SET_POLICY', data);
    },

    find({ commit, state }) {
      let url = `/support_warranty?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('supportWarrantyPolicy'));
          return response.body;
        })
        .then((response) => {
          commit('SET_POLICIES', response);
        });
    },

    findById({ commit }, id) {
      return http(`/support_warranty/${id}`)
        .then((response) => response.body)
        .then(typeAs('supportWarrantyPolicy'))
        .then((item) => {
          commit('SET_POLICY', item);
        });
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/support_warranty/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    destroy(_, id) {
      return http(`/support_warranty/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/support_warranty/${id}`, { method: 'PUT', data })
        : http('/support_warranty', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    allByCategory(_, id) {
      return http(`/support_warranty/${id}/waranty_product_subcategories`)
        .then((response) => response.body);
    },

    allBySubCateogry(_, id) {
      return http(`/support_warranty/${id}/waranty_products`)
        .then((response) => response.body);
    },
  },
};
